import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../auth/authProvider";
import { changePasswordApi } from "../../api";
import styles from "./Profile.module.css";

export const Profile: React.FC = () => {
    const { username, getAuthToken, isLocalAuth } = useAuth();
    const { t } = useTranslation();

    const [oldPassword, setOldPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [error, setError] = useState("");
    const [message, setMessage] = useState("");

    const handleChangePassword = async (e: React.FormEvent) => {
        e.preventDefault();
        setError("");
        setMessage("");

        if (newPassword !== confirmPassword) {
            setError(t("passwordChange.errorPasswordsDoNotMatch"));
            return;
        }

        if (!oldPassword || !newPassword) {
            setError(t("passwordChange.errorAllFieldsRequired"));
            return;
        }

        const token = await getAuthToken();
        if (token) {
            try {
                const response = await changePasswordApi(token, oldPassword, newPassword);
                setMessage(t(response.message));
                // Clear fields on success
                setOldPassword("");
                setNewPassword("");
                setConfirmPassword("");
            } catch (err: any) {
                setError(t(err.message));
            }
        }
    };

    if (!isLocalAuth) {
        return (
            <div className={styles.profileContainer}>
                <h1>{t("profile.title")}</h1>
                <p>{t("profile.mfaOnlyForLocal")}</p>
            </div>
        );
    }

    return (
        <div className={styles.profileContainer}>
            <h1>{t("profile.title")}</h1>
            <h2>{t("profile.welcome", { username: username })}</h2>

            <div className={styles.mfaSection}>
                <h3>{t("passwordChange.title")}</h3>
                <form onSubmit={handleChangePassword} className={styles.form}>
                    <input
                        type="password"
                        value={oldPassword}
                        onChange={e => setOldPassword(e.target.value)}
                        placeholder={t("passwordChange.placeholderCurrentPassword")}
                        required
                        className={styles.input}
                    />
                    <input
                        type="password"
                        value={newPassword}
                        onChange={e => setNewPassword(e.target.value)}
                        placeholder={t("passwordChange.placeholderNewPassword")}
                        required
                        className={styles.input}
                    />
                    <input
                        type="password"
                        value={confirmPassword}
                        onChange={e => setConfirmPassword(e.target.value)}
                        placeholder={t("passwordChange.placeholderConfirmPassword")}
                        required
                        className={styles.input}
                    />
                    <button type="submit" className={styles.button}>
                        {t("passwordChange.updateButton")}
                    </button>
                </form>
                {message && <p className={styles.message}>{message}</p>}
                {error && <p className={styles.error}>{error}</p>}
            </div>
        </div>
    );
};
